import React, { useState } from 'react';
import PdfFlipModal from '../components/PdfFlipModal';

const Reglamentos = () => {
    const [modalPdf, setModalPdf] = useState(null);

    return (
        <>
        <div className='container fondotransparente p-5 my-5 '>
            <center><h1 className="p-5 botonbordeazul text-white px-5 mx-5 py-3">Leyes y Reglamentos</h1></center>
            <br />
            <p>Encontrá todas las Leyes y Reglamentos publicados en InProJuy.</p>
            <br /><br />

            <h3><strong>Leyes</strong></h3>
            <ul>
                <li className='h5 sinvineta'>
                    <a href="./download/LEY-DE-CREACION-DEL-INSTITUTO-DE-JUEGOS-DE-AZAR-DE-JUJUY.pdf" download>
                        LEY DE CREACIÓN DEL INSTITUTO DE JUEGOS DE AZAR DE JUJUY
                    </a>
                </li>
            </ul>
            <br />
            <hr className="wp-block-separator has-css-opacity" />
            <br />

            <h3><strong>Reglamentos de Juegos</strong></h3>
            <ul>
                <li className='h5 sinvineta'><a href="./download/reglamento-tombola.pdf" download >REGLAMENTO DE TÓMBOLA</a></li>
                <li className='h5 sinvineta'><a href="https://firebasestorage.googleapis.com/v0/b/inprojuy-f1173.appspot.com/o/descargas%2FReglamento%20Tombo%20Express.pdf?alt=media&token=b7658791-1413-4818-beee-f98b20df9169" download >REGLAMENTO TOMBO EXPRESS</a></li>
                <li className='h5 sinvineta'><a href="./download/BetWarrior.pdf" download >REGLAMENTO BETWARRIOR</a></li>
                <li className='h5 sinvineta'><a href="./download/reglamento-bingos-rifas-bonos.pdf" download >REGLAMENTO DE BINGOS, RIFAS, LOTAS, BONOS CONTRIBUCIÓN</a>
                    <a href="./download/R33-p-2024.pdf" download >, Resolución N° 033-P-2024</a>
                </li>
                <li className='h5 sinvineta'><a href="./download/Reglamento_de_Juego_OnLine.pdf" download >REGLAMENTO DE JUEGO ON LINE</a>
                    <a href="./download/R568-p-2023.pdf" download >, Resolución N° 568-P-2023</a>
                </li>
                <li className='h5 sinvineta'><a href="./download/Reglamento-TV-BINGO-BONAERENSE-TELEKINO-2023-1.pdf" download>REGLAMENTO TELEKINO</a></li>
                <li className='h5 sinvineta'><a href="./download/Reglamento_de_Salas_Tragamonedas.pdf" download>REGLAMENTO DE SALAS TRAGAMONEDAS</a>
                    <a href="./download/R296-p-2023.pdf" download >, Resolución N° 296-P-2023</a>
                </li>
            </ul>
            <br />

            <h3><strong>Manuales y Procedimientos</strong></h3>
            <ul>
                <li className='h5 sinvineta'><a href="./download/MANUAL-PREVENCION-LAVADO-ACTIVOS.pdf" download>MANUAL DE PREVENCIÓN DE LAVADO DE ACTIVOS Y FINANCIAMIENTO DEL TERRORISMO</a></li>
                <li className='h5 sinvineta'><a href="./download/Procedimiento-Sorteos-Tombola-Inprojuy.pdf" download >MANUAL DE PROCEDIMIENTO DE SORTEO DE TÓMBOLA</a></li>
            </ul>
            <br />

            <h3><strong>Concursos</strong></h3>
            <ul>
                <li className='h5 sinvineta'>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/inprojuy-f1173.appspot.com/o/descargas%2FBases%20y%20Condicionesnuevo.pdf?alt=media&token=229ed67e-8fc6-4986-9692-b2615131f124"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Bases y Condiciones - Concurso de Decoración de Agencias y Subagencias
                    </a>
                </li>
            </ul>
            <br />

            <h3><strong>Requisitos y Buenas Prácticas</strong></h3>
            <ul>
                <li className='h5 sinvineta'><a href="https://firebasestorage.googleapis.com/v0/b/inprojuy-f1173.appspot.com/o/REQUISITOS%20BINGOS.pdf?alt=media&token=77ecfd6e-e0e2-46d1-aefa-ca52c3c868b6" download >REQUISITOS PARA ORGANIZAR BINGOS, RIFAS, BINGO-RIFAS, LOTAS, BONO CONTRIBUCION, BONOS CONTRIBUCION ESCOLAR</a></li>
                <li className='h5 sinvineta'><a href="./download/buenaspalea.pdf" download >Acta de buenas practicas para la publicidad responsable de Juegos de Azar Online en Argentina</a></li>
                <li className='h5 sinvineta'>
                    <a href="#" onClick={(e) => { e.preventDefault(); setModalPdf({ url: 'https://firebasestorage.googleapis.com/v0/b/inprojuy-f1173.appspot.com/o/INPROJUY%20-%20C%C3%B3digo%20de%20buenas%20pr%C3%A1cticas.pdf?alt=media', title: 'Código de buenas prácticas' }); }}>
                        Código de buenas prácticas
                    </a>
                </li>
                <li className='h5 sinvineta'>
                    <a href="#" onClick={(e) => { e.preventDefault(); setModalPdf({ url: 'https://firebasestorage.googleapis.com/v0/b/inprojuy-f1173.appspot.com/o/INPROJUY%20-%20Acta%20de%20adhesion%20al%20cod.%20de%20compromiso%20de%20buenas%20pr%C3%A1cticas.pdf?alt=media', title: 'Acta de adhesión al código de compromiso de buenas prácticas' }); }}>
                        Acta de adhesión al código de compromiso de buenas prácticas
                    </a>
                </li>
            </ul>
            <br />
        </div>

        <PdfFlipModal
            show={!!modalPdf}
            onHide={() => setModalPdf(null)}
            pdfUrl={modalPdf?.url}
            title={modalPdf?.title}
        />
        </>
    )
}

export default Reglamentos;